import React from 'react';

const ExecutiveSummary = () => {
  const styles = {
    container: {
      width: '100%',
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '32px',
      background: 'linear-gradient(to bottom right, #f8fafc, #e0f2fe)',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    },
    card: {
      background: 'white',
      borderRadius: '16px',
      boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
      padding: '32px',
    },
    header: {
      borderBottom: '4px solid #2563eb',
      paddingBottom: '24px',
      marginBottom: '32px',
    },
    title: {
      fontSize: '48px',
      fontWeight: 'bold',
      color: '#1e293b',
      marginBottom: '12px',
    },
    subtitle: {
      fontSize: '24px',
      color: '#2563eb',
      fontWeight: '600',
      marginBottom: '8px',
    },
    description: {
      color: '#64748b',
      marginTop: '8px',
    },
    badge: {
      display: 'inline-block',
      background: '#fbbf24',
      color: '#78350f',
      padding: '6px 16px',
      borderRadius: '12px',
      fontSize: '13px',
      fontWeight: 'bold',
      marginTop: '12px',
      marginRight: '8px',
    },
    redeprogBadge: {
      display: 'inline-block',
      background: 'linear-gradient(45deg, #1976d2, #4caf50)',
      color: 'white',
      padding: '8px 20px',
      borderRadius: '20px',
      fontSize: '15px',
      fontWeight: 'bold',
      marginTop: '12px',
    },
    metricsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
      gap: '24px',
      marginBottom: '32px',
    },
    metricCard: (bgColor) => ({
      background: `linear-gradient(to bottom right, ${bgColor}, ${bgColor}dd)`,
      borderRadius: '12px',
      padding: '24px',
      color: 'white',
      boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
    }),
    sectionTitle: {
      fontSize: '24px',
      fontWeight: 'bold',
      color: '#1e293b',
      marginBottom: '16px',
      display: 'flex',
      alignItems: 'center',
      marginTop: '32px',
    },
    badgeNumber: {
      background: '#dbeafe',
      color: '#2563eb',
      borderRadius: '50%',
      width: '32px',
      height: '32px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: '12px',
      fontSize: '14px',
      fontWeight: 'bold',
    },
    contentBox: (bgColor) => ({
      background: bgColor,
      borderRadius: '12px',
      padding: '24px',
      marginBottom: '16px',
    }),
    grid2: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: '24px',
      marginBottom: '24px',
    },
    list: {
      listStyle: 'none',
      padding: 0,
      margin: 0,
    },
    listItem: {
      display: 'flex',
      alignItems: 'flex-start',
      marginBottom: '12px',
      color: '#475569',
    },
    bullet: (color) => ({
      color: color,
      marginRight: '8px',
      fontSize: '18px',
    }),
  };

  const technologies = ['React.js', '.NET Core', 'React Native', 'Blockchain', 'IA & ML', 'Cloud Azure/AWS'];

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.header}>
          <h1 style={styles.title}>Tracker ON</h1>
          <h2 style={styles.subtitle}>Resumen Ejecutivo del Proyecto</h2>
          <p style={styles.description}>Sistema Integral de Gestión y Seguimiento de Proyectos con Blockchain</p>
          <div style={{marginTop: '16px'}}>
            <span style={styles.badge}>💵 Valores en Dólares USD</span>
            <span style={styles.redeprogBadge}>🏢 Desarrollado por Redeprog</span>
          </div>
        </div>

        <div style={styles.metricsGrid}>
          <div style={styles.metricCard('#3b82f6')}>
            <div style={{fontSize: '14px', opacity: 0.9, marginBottom: '8px'}}>Inversión Total</div>
            <div style={{fontSize: '40px', fontWeight: 'bold'}}>$95,000</div>
            <div style={{fontSize: '14px', marginTop: '8px'}}>USD - Fase 1 + Fase 2 + IA</div>
          </div>
          <div style={styles.metricCard('#10b981')}>
            <div style={{fontSize: '14px', opacity: 0.9, marginBottom: '8px'}}>Potencial Año 3 (SaaS)</div>
            <div style={{fontSize: '40px', fontWeight: 'bold'}}>$510K</div>
            <div style={{fontSize: '14px', marginTop: '8px'}}>USD ARR con 40 clientes</div>
          </div>
          <div style={styles.metricCard('#a855f7')}>
            <div style={{fontSize: '14px', opacity: 0.9, marginBottom: '8px'}}>Valuación Proyectada</div>
            <div style={{fontSize: '40px', fontWeight: 'bold'}}>$4.0M</div>
            <div style={{fontSize: '14px', marginTop: '8px'}}>USD - Múltiplo 8x ARR</div>
          </div>
        </div>

        <section>
          <h3 style={styles.sectionTitle}>
            <span style={styles.badgeNumber}>1</span>
            Estado Actual del Proyecto
          </h3>
          <div style={styles.contentBox('#eff6ff')}>
            <div style={styles.grid2}>
              <div>
                <h4 style={{fontWeight: 'bold', color: '#1e40af', marginBottom: '12px'}}>✓ Fase 1 Completada</h4>
                <ul style={styles.list}>
                  <li style={styles.listItem}>
                    <span style={styles.bullet('#10b981')}>●</span>
                    <span><strong>Backend:</strong> .NET Core completo y operativo</span>
                  </li>
                  <li style={styles.listItem}>
                    <span style={styles.bullet('#10b981')}>●</span>
                    <span><strong>Frontend:</strong> React.js con UI moderna</span>
                  </li>
                  <li style={styles.listItem}>
                    <span style={styles.bullet('#10b981')}>●</span>
                    <span><strong>Infraestructura:</strong> Google Maps, Firebase</span>
                  </li>
                  <li style={styles.listItem}>
                    <span style={styles.bullet('#10b981')}>●</span>
                    <span><strong>Módulos:</strong> 5 módulos funcionales</span>
                  </li>
                  <li style={styles.listItem}>
                    <span style={styles.bullet('#10b981')}>●</span>
                    <span><strong>Inversión:</strong> $35,000 USD | 700 horas</span>
                  </li>
                </ul>
              </div>
              <div>
                <h4 style={{fontWeight: 'bold', color: '#c2410c', marginBottom: '12px'}}>→ Fase 2 Pendiente</h4>
                <ul style={styles.list}>
                  <li style={styles.listItem}>
                    <span style={styles.bullet('#f97316')}>●</span>
                    <span><strong>3 Workflows:</strong> Empresa, Adjudicación, Seguimiento</span>
                  </li>
                  <li style={styles.listItem}>
                    <span style={styles.bullet('#f97316')}>●</span>
                    <span><strong>5 Gadgets:</strong> Alertas, Dashboards, Reportes</span>
                  </li>
                  <li style={styles.listItem}>
                    <span style={styles.bullet('#f97316')}>●</span>
                    <span><strong>App Móvil:</strong> iOS + Android (React Native)</span>
                  </li>
                  <li style={styles.listItem}>
                    <span style={styles.bullet('#f97316')}>●</span>
                    <span><strong>Blockchain:</strong> Integración completa</span>
                  </li>
                  <li style={styles.listItem}>
                    <span style={styles.bullet('#f97316')}>●</span>
                    <span><strong>Inversión:</strong> $47,000 USD desarrollo + $8,000 USD IA | 1,340 horas</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section>
          <h3 style={styles.sectionTitle}>
            <span style={styles.badgeNumber}>2</span>
            Impacto de la Inteligencia Artificial
          </h3>
          <div style={styles.contentBox('linear-gradient(to right, #faf5ff, #eff6ff)')}>
            <div style={{marginBottom: '16px', padding: '12px', background: '#fef3c7', borderRadius: '8px', border: '2px solid #fbbf24'}}>
              <p style={{fontSize: '14px', color: '#78350f', margin: 0, fontWeight: 'bold'}}>
                🤖 Inversión en IA: $8,000 USD - GitHub Copilot, ChatGPT-4, Claude Pro, Cursor IDE
              </p>
            </div>
            <div style={{display: 'flex', gap: '16px', marginBottom: '16px', flexWrap: 'wrap'}}>
              <div style={{flex: 1, minWidth: '150px', background: 'white', borderRadius: '8px', padding: '16px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)'}}>
                <div style={{fontSize: '32px', fontWeight: 'bold', color: '#ef4444'}}>1,340h</div>
                <div style={{fontSize: '14px', color: '#64748b'}}>Sin IA (100% manual)</div>
              </div>
              <div style={{flex: 1, minWidth: '150px', background: 'white', borderRadius: '8px', padding: '16px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)'}}>
                <div style={{fontSize: '32px', fontWeight: 'bold', color: '#10b981'}}>744h</div>
                <div style={{fontSize: '14px', color: '#64748b'}}>Con IA (40% automatización)</div>
              </div>
              <div style={{flex: 1, minWidth: '150px', background: 'white', borderRadius: '8px', padding: '16px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)'}}>
                <div style={{fontSize: '32px', fontWeight: 'bold', color: '#3b82f6'}}>596h</div>
                <div style={{fontSize: '14px', color: '#64748b'}}>Ahorro total (44%)</div>
              </div>
            </div>
            <div style={{fontSize: '14px', color: '#475569', lineHeight: '1.6'}}>
              <strong>Estrategia Redeprog:</strong> La IA acelera código base, testing y documentación (40% más rápido), 
              mientras que desarrolladores senior se enfocan en arquitectura y lógica de negocio compleja (60% trabajo humano crítico).
            </div>
          </div>
        </section>

        <section>
          <h3 style={styles.sectionTitle}>
            <span style={styles.badgeNumber}>3</span>
            Modelos de Comercialización
          </h3>
          
          <div style={styles.grid2}>
            <div style={{border: '2px solid #3b82f6', borderRadius: '12px', padding: '24px', background: '#eff6ff'}}>
              <h4 style={{fontSize: '20px', fontWeight: 'bold', color: '#1e40af', marginBottom: '16px'}}>🏢 Licencia Enterprise</h4>
              <div>
                <div style={{display: 'flex', justifyContent: 'space-between', padding: '12px 0', borderBottom: '1px solid #bfdbfe'}}>
                  <span style={{color: '#475569'}}>Precio por licencia:</span>
                  <span style={{fontWeight: 'bold', color: '#2563eb'}}>$100K-$150K USD</span>
                </div>
                <div style={{display: 'flex', justifyContent: 'space-between', padding: '12px 0', borderBottom: '1px solid #bfdbfe'}}>
                  <span style={{color: '#475569'}}>Mantenimiento/año:</span>
                  <span style={{fontWeight: 'bold', color: '#475569'}}>$20K-$30K USD</span>
                </div>
                <div style={{display: 'flex', justifyContent: 'space-between', padding: '12px 0', borderBottom: '1px solid #bfdbfe'}}>
                  <span style={{color: '#475569'}}>Propiedad IP:</span>
                  <span style={{fontWeight: 'bold', color: '#10b981'}}>✅ Mantiene Redeprog</span>
                </div>
                <div style={{display: 'flex', justifyContent: 'space-between', padding: '12px 0', paddingTop: '16px'}}>
                  <span style={{color: '#475569', fontWeight: '600'}}>Permite SaaS:</span>
                  <span style={{fontWeight: 'bold', color: '#10b981', fontSize: '20px'}}>✅ SÍ</span>
                </div>
              </div>
              <div style={{marginTop: '16px', padding: '12px', background: 'white', borderRadius: '8px'}}>
                <div style={{fontSize: '14px', color: '#10b981', marginBottom: '4px'}}>✓ Liquidez inmediata</div>
                <div style={{fontSize: '14px', color: '#10b981', marginBottom: '4px'}}>✓ Mantiene IP</div>
                <div style={{fontSize: '14px', color: '#10b981'}}>✓ Puede hacer SaaS</div>
              </div>
            </div>

            <div style={{border: '2px solid #10b981', borderRadius: '12px', padding: '24px', background: '#f0fdf4'}}>
              <h4 style={{fontSize: '20px', fontWeight: 'bold', color: '#065f46', marginBottom: '16px'}}>☁️ Modelo SaaS</h4>
              <div style={{marginBottom: '12px', padding: '8px', background: 'white', borderRadius: '8px', fontSize: '12px', color: '#475569'}}>
                <strong>ARR:</strong> Annual Recurring Revenue (Ingresos Anuales Recurrentes)
              </div>
              <div>
                <div style={{display: 'flex', justifyContent: 'space-between', padding: '12px 0', borderBottom: '1px solid #bbf7d0'}}>
                  <span style={{color: '#475569'}}>ARR Año 1:</span>
                  <span style={{fontWeight: 'bold', color: '#10b981'}}>$101,930 USD</span>
                </div>
                <div style={{display: 'flex', justifyContent: 'space-between', padding: '12px 0', borderBottom: '1px solid #bbf7d0'}}>
                  <span style={{color: '#475569'}}>ARR Año 2:</span>
                  <span style={{fontWeight: 'bold', color: '#10b981'}}>$254,825 USD</span>
                </div>
                <div style={{display: 'flex', justifyContent: 'space-between', padding: '12px 0', borderBottom: '1px solid #bbf7d0'}}>
                  <span style={{color: '#475569'}}>ARR Año 3:</span>
                  <span style={{fontWeight: 'bold', color: '#10b981'}}>$509,650 USD</span>
                </div>
                <div style={{display: 'flex', justifyContent: 'space-between', padding: '12px 0', paddingTop: '16px'}}>
                  <span style={{color: '#475569', fontWeight: '600'}}>Ganancia 3 años:</span>
                  <span style={{fontWeight: 'bold', color: '#10b981', fontSize: '20px'}}>$583,905 USD</span>
                </div>
              </div>
              <div style={{marginTop: '16px', padding: '12px', background: 'white', borderRadius: '8px'}}>
                <div style={{fontSize: '14px', color: '#10b981', marginBottom: '4px'}}>✓ Escalabilidad exponencial</div>
                <div style={{fontSize: '14px', color: '#10b981', marginBottom: '4px'}}>✓ Propiedad intelectual</div>
                <div style={{fontSize: '14px', color: '#ef4444'}}>✗ Retorno más lento (9-12 meses)</div>
              </div>
            </div>
          </div>

          <div style={{background: 'linear-gradient(to right, #2563eb, #10b981)', borderRadius: '12px', padding: '24px', color: 'white', marginTop: '24px'}}>
            <h4 style={{fontSize: '20px', fontWeight: 'bold', marginBottom: '12px'}}>💡 Estrategia Híbrida Recomendada</h4>
            <div style={{fontSize: '14px', lineHeight: '1.6'}}>
              <p style={{margin: 0, marginBottom: '8px'}}><strong>Paso 1:</strong> Vender 2-3 Licencias Enterprise ($100K-$150K USD c/u) para generar capital</p>
              <p style={{margin: 0, marginBottom: '8px'}}><strong>Paso 2:</strong> Usar ese capital para completar Fase 2 y lanzar versión SaaS</p>
              <p style={{margin: 0, marginBottom: '8px'}}><strong>Paso 3:</strong> Operar ambos modelos simultáneamente</p>
              <p style={{margin: 0, paddingTop: '12px', borderTop: '1px solid rgba(255,255,255,0.3)'}}>
                <strong>Resultado:</strong> Liquidez inmediata + Crecimiento escalable + Valuación empresarial creciente
              </p>
            </div>
          </div>

          <div style={{marginTop: '24px', padding: '24px', background: '#fff7ed', borderRadius: '12px', border: '2px solid #f97316'}}>
            <h4 style={{fontSize: '18px', fontWeight: 'bold', color: '#9a3412', marginBottom: '16px'}}>⚠️ Condiciones Críticas para Estrategia Híbrida</h4>
            <div style={{fontSize: '14px', color: '#78350f', lineHeight: '1.8'}}>
              <div style={{marginBottom: '12px'}}>
                <strong style={{color: '#065f46'}}>✓ Lo que SÍ se puede hacer:</strong>
                <ul style={{marginTop: '8px', marginLeft: '20px', marginBottom: 0}}>
                  <li>Vender <strong>LICENCIAS de uso</strong> (no la propiedad intelectual)</li>
                  <li>Ofrecer instalación <strong>on-premise</strong> personalizada</li>
                  <li>Mantener <strong>propiedad del código fuente</strong></li>
                  <li>Operar <strong>SaaS simultáneamente</strong> con el código core</li>
                </ul>
              </div>
              <div>
                <strong style={{color: '#991b1b'}}>✗ Lo que NO se debe hacer:</strong>
                <ul style={{marginTop: '8px', marginLeft: '20px', marginBottom: 0}}>
                  <li>Transferir <strong>propiedad intelectual completa</strong></li>
                  <li>Entregar el <strong>código fuente</strong> al cliente</li>
                  <li>Dar <strong>exclusividad</strong> del software</li>
                  <li>Ceder <strong>derechos de modificación</strong> del core</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section>
          <h3 style={styles.sectionTitle}>
            <span style={styles.badgeNumber}>4</span>
            Comparación Detallada de Modelos
          </h3>
          
          <div style={{overflowX: 'auto'}}>
            <table style={{width: '100%', borderCollapse: 'collapse', background: 'white', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 2px 4px rgba(0,0,0,0.1)'}}>
              <thead>
                <tr style={{background: 'linear-gradient(135deg, #1e40af, #1e3a8a)'}}>
                  <th style={{padding: '16px', textAlign: 'left', color: 'white', fontWeight: 'bold'}}>Aspecto</th>
                  <th style={{padding: '16px', textAlign: 'center', color: 'white', fontWeight: 'bold'}}>Venta Total IP</th>
                  <th style={{padding: '16px', textAlign: 'center', color: 'white', fontWeight: 'bold'}}>Licencia Enterprise</th>
                  <th style={{padding: '16px', textAlign: 'center', color: 'white', fontWeight: 'bold'}}>SaaS Puro</th>
                </tr>
              </thead>
              <tbody>
                <tr style={{borderBottom: '1px solid #e2e8f0'}}>
                  <td style={{padding: '12px', fontWeight: '600', color: '#475569'}}>Precio Inicial</td>
                  <td style={{padding: '12px', textAlign: 'center', color: '#059669', fontWeight: 'bold'}}>$180K-$250K</td>
                  <td style={{padding: '12px', textAlign: 'center', color: '#059669', fontWeight: 'bold'}}>$100K-$150K</td>
                  <td style={{padding: '12px', textAlign: 'center', color: '#64748b'}}>$0</td>
                </tr>
                <tr style={{borderBottom: '1px solid #e2e8f0', background: '#f8fafc'}}>
                  <td style={{padding: '12px', fontWeight: '600', color: '#475569'}}>Propiedad IP</td>
                  <td style={{padding: '12px', textAlign: 'center', color: '#dc2626'}}>❌ Pierde Redeprog</td>
                  <td style={{padding: '12px', textAlign: 'center', color: '#059669'}}>✅ Mantiene Redeprog</td>
                  <td style={{padding: '12px', textAlign: 'center', color: '#059669'}}>✅ Mantiene Redeprog</td>
                </tr>
                <tr style={{borderBottom: '1px solid #e2e8f0'}}>
                  <td style={{padding: '12px', fontWeight: '600', color: '#475569'}}>Código Fuente</td>
                  <td style={{padding: '12px', textAlign: 'center', color: '#dc2626'}}>✅ Cliente lo tiene</td>
                  <td style={{padding: '12px', textAlign: 'center', color: '#059669'}}>❌ NO se entrega</td>
                  <td style={{padding: '12px', textAlign: 'center', color: '#059669'}}>❌ Nadie externo</td>
                </tr>
                <tr style={{borderBottom: '1px solid #e2e8f0', background: '#f8fafc'}}>
                  <td style={{padding: '12px', fontWeight: '600', color: '#475569'}}>Uso para SaaS</td>
                  <td style={{padding: '12px', textAlign: 'center', color: '#dc2626', fontWeight: 'bold'}}>❌ IMPOSIBLE</td>
                  <td style={{padding: '12px', textAlign: 'center', color: '#059669', fontWeight: 'bold'}}>✅ POSIBLE</td>
                  <td style={{padding: '12px', textAlign: 'center', color: '#059669'}}>✅ Es SaaS</td>
                </tr>
                <tr style={{borderBottom: '1px solid #e2e8f0'}}>
                  <td style={{padding: '12px', fontWeight: '600', color: '#475569'}}>Personalización</td>
                  <td style={{padding: '12px', textAlign: 'center', color: '#059669'}}>✅ Total</td>
                  <td style={{padding: '12px', textAlign: 'center', color: '#059669'}}>✅ Moderada</td>
                  <td style={{padding: '12px', textAlign: 'center', color: '#f59e0b'}}>⚠️ Limitada</td>
                </tr>
                <tr style={{borderBottom: '1px solid #e2e8f0', background: '#f8fafc'}}>
                  <td style={{padding: '12px', fontWeight: '600', color: '#475569'}}>Instalación</td>
                  <td style={{padding: '12px', textAlign: 'center'}}>On-premise</td>
                  <td style={{padding: '12px', textAlign: 'center'}}>On-premise</td>
                  <td style={{padding: '12px', textAlign: 'center'}}>Cloud</td>
                </tr>
                <tr style={{borderBottom: '1px solid #e2e8f0'}}>
                  <td style={{padding: '12px', fontWeight: '600', color: '#475569'}}>Mantenimiento</td>
                  <td style={{padding: '12px', textAlign: 'center', color: '#64748b'}}>Cliente responsable</td>
                  <td style={{padding: '12px', textAlign: 'center', color: '#059669'}}>$20K-$30K/año</td>
                  <td style={{padding: '12px', textAlign: 'center', color: '#059669'}}>Incluido</td>
                </tr>
                <tr style={{borderBottom: '1px solid #e2e8f0', background: '#f8fafc'}}>
                  <td style={{padding: '12px', fontWeight: '600', color: '#475569'}}>Escalabilidad</td>
                  <td style={{padding: '12px', textAlign: 'center', color: '#dc2626'}}>❌ Ninguna</td>
                  <td style={{padding: '12px', textAlign: 'center', color: '#f59e0b'}}>⚠️ Limitada (3-5)</td>
                  <td style={{padding: '12px', textAlign: 'center', color: '#059669', fontWeight: 'bold'}}>✅ Infinita</td>
                </tr>
                <tr>
                  <td style={{padding: '12px', fontWeight: '600', color: '#475569'}}>Valuación Empresa</td>
                  <td style={{padding: '12px', textAlign: 'center', color: '#dc2626'}}>$0 (vendiste todo)</td>
                  <td style={{padding: '12px', textAlign: 'center', color: '#059669'}}>$800K-$1.6M</td>
                  <td style={{padding: '12px', textAlign: 'center', color: '#059669', fontWeight: 'bold'}}>$4M+</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div style={{marginTop: '24px', padding: '20px', background: 'linear-gradient(135deg, #ecfdf5, #d1fae5)', borderRadius: '12px', border: '2px solid #10b981'}}>
            <h4 style={{fontSize: '18px', fontWeight: 'bold', color: '#065f46', marginBottom: '12px'}}>✅ Modelo Recomendado: Licencia Enterprise + SaaS</h4>
            <p style={{fontSize: '14px', color: '#064e3b', lineHeight: '1.6', margin: 0}}>
              Este modelo híbrido permite obtener liquidez inmediata manteniendo la propiedad intelectual. 
              Redeprog conserva todos los derechos sobre el código y puede escalar con SaaS mientras 
              atiende clientes enterprise con instalaciones dedicadas.
            </p>
          </div>
        </section>

        <section>
          <h3 style={styles.sectionTitle}>
            <span style={styles.badgeNumber}>5</span>
            Proyección Financiera Estrategia Híbrida
          </h3>

          <div style={{background: 'white', borderRadius: '12px', padding: '24px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)'}}>
            <div style={styles.grid2}>
              <div>
                <h4 style={{fontSize: '18px', fontWeight: 'bold', color: '#1e40af', marginBottom: '16px'}}>📅 Año 1: Financiamiento</h4>
                <div style={{fontSize: '14px', color: '#475569', lineHeight: '1.8'}}>
                  <div style={{display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #e2e8f0'}}>
                    <span>3 Licencias Enterprise</span>
                    <strong style={{color: '#059669'}}>+$300,000</strong>
                  </div>
                  <div style={{display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #e2e8f0'}}>
                    <span>Desarrollo Fase 2</span>
                    <strong style={{color: '#dc2626'}}>-$60,000</strong>
                  </div>
                  <div style={{display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #e2e8f0'}}>
                    <span>Costos operativos</span>
                    <strong style={{color: '#dc2626'}}>-$40,000</strong>
                  </div>
                  <div style={{display: 'flex', justifyContent: 'space-between', padding: '12px 0', paddingTop: '16px', fontWeight: 'bold', fontSize: '16px'}}>
                    <span>Ganancia Neta Año 1</span>
                    <strong style={{color: '#059669'}}>$200,000</strong>
                  </div>
                </div>
              </div>

              <div>
                <h4 style={{fontSize: '18px', fontWeight: 'bold', color: '#7c3aed', marginBottom: '16px'}}>📅 Año 2: Crecimiento</h4>
                <div style={{fontSize: '14px', color: '#475569', lineHeight: '1.8'}}>
                  <div style={{display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #e2e8f0'}}>
                    <span>2 Licencias Enterprise</span>
                    <strong style={{color: '#059669'}}>+$200,000</strong>
                  </div>
                  <div style={{display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #e2e8f0'}}>
                    <span>8 Clientes SaaS (ARR)</span>
                    <strong style={{color: '#059669'}}>+$67,000</strong>
                  </div>
                  <div style={{display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #e2e8f0'}}>
                    <span>Mantenimiento licencias</span>
                    <strong style={{color: '#059669'}}>+$60,000</strong>
                  </div>
                  <div style={{display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #e2e8f0'}}>
                    <span>Costos operativos</span>
                    <strong style={{color: '#dc2626'}}>-$85,000</strong>
                  </div>
                  <div style={{display: 'flex', justifyContent: 'space-between', padding: '12px 0', paddingTop: '16px', fontWeight: 'bold', fontSize: '16px'}}>
                    <span>Ganancia Neta Año 2</span>
                    <strong style={{color: '#059669'}}>$242,000</strong>
                  </div>
                </div>
              </div>
            </div>

            <div style={{marginTop: '24px', padding: '20px', background: 'linear-gradient(to right, #3b82f6, #8b5cf6)', borderRadius: '12px', color: 'white'}}>
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px'}}>
                <div>
                  <div style={{fontSize: '14px', opacity: 0.9, marginBottom: '4px'}}>Total Ganancia 3 Años</div>
                  <div style={{fontSize: '32px', fontWeight: 'bold'}}>$716,000 USD</div>
                </div>
                <div>
                  <div style={{fontSize: '14px', opacity: 0.9, marginBottom: '4px'}}>Valuación Empresa Año 3</div>
                  <div style={{fontSize: '32px', fontWeight: 'bold'}}>$1.6M USD</div>
                </div>
                <div>
                  <div style={{fontSize: '14px', opacity: 0.9, marginBottom: '4px'}}>ROI sobre inversión</div>
                  <div style={{fontSize: '32px', fontWeight: 'bold'}}>753%</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <h3 style={styles.sectionTitle}>
            <span style={styles.badgeNumber}>6</span>
            Planes de Precios SaaS (USD/mes)
          </h3>
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '16px'}}>
            <div style={{background: 'white', borderRadius: '8px', border: '2px solid #e2e8f0', padding: '16px'}}>
              <div style={{fontSize: '12px', color: '#64748b', marginBottom: '4px'}}>BÁSICO</div>
              <div style={{fontSize: '24px', fontWeight: 'bold', color: '#2563eb'}}>$350</div>
              <div style={{fontSize: '12px', color: '#64748b'}}>/mes USD</div>
            </div>
            <div style={{background: '#eff6ff', borderRadius: '8px', border: '2px solid #3b82f6', padding: '16px'}}>
              <div style={{fontSize: '12px', color: '#2563eb', fontWeight: 'bold', marginBottom: '4px'}}>POPULAR</div>
              <div style={{fontSize: '24px', fontWeight: 'bold', color: '#2563eb'}}>$700</div>
              <div style={{fontSize: '12px', color: '#64748b'}}>/mes USD</div>
            </div>
            <div style={{background: 'white', borderRadius: '8px', border: '2px solid #e2e8f0', padding: '16px'}}>
              <div style={{fontSize: '12px', color: '#64748b', marginBottom: '4px'}}>ENTERPRISE</div>
              <div style={{fontSize: '24px', fontWeight: 'bold', color: '#2563eb'}}>$1,750</div>
              <div style={{fontSize: '12px', color: '#64748b'}}>/mes USD</div>
            </div>
            <div style={{background: '#f0fdf4', borderRadius: '8px', border: '2px solid #10b981', padding: '16px'}}>
              <div style={{fontSize: '12px', color: '#10b981', fontWeight: 'bold', marginBottom: '4px'}}>GOBIERNO</div>
              <div style={{fontSize: '24px', fontWeight: 'bold', color: '#10b981'}}>$3,500</div>
              <div style={{fontSize: '12px', color: '#64748b'}}>/mes USD</div>
            </div>
          </div>
        </section>

        <section>
          <h3 style={styles.sectionTitle}>
            <span style={styles.badgeNumber}>7</span>
            Redeprog - Empresa Desarrolladora
          </h3>
          <div style={{background: 'linear-gradient(135deg, #1976d2, #4caf50)', borderRadius: '12px', padding: '32px', color: 'white'}}>
            <h4 style={{fontSize: '24px', fontWeight: 'bold', marginBottom: '16px'}}>🏢 Sobre Redeprog</h4>
            <p style={{fontSize: '16px', opacity: 0.95, lineHeight: '1.7', marginBottom: '16px'}}>
              Somos una empresa colombiana especializada en el desarrollo de soluciones tecnológicas de vanguardia. 
              Nuestro equipo combina la experiencia en desarrollo tradicional con las últimas herramientas de 
              Inteligencia Artificial para entregar proyectos de alta calidad en menos tiempo.
            </p>
            <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px', marginTop: '24px'}}>
              <div style={{background: 'rgba(255,255,255,0.15)', borderRadius: '8px', padding: '16px'}}>
                <div style={{fontSize: '14px', opacity: 0.9, marginBottom: '4px'}}>Experiencia</div>
                <div style={{fontSize: '24px', fontWeight: 'bold'}}>10+ años</div>
              </div>
              <div style={{background: 'rgba(255,255,255,0.15)', borderRadius: '8px', padding: '16px'}}>
                <div style={{fontSize: '14px', opacity: 0.9, marginBottom: '4px'}}>Proyectos Entregados</div>
                <div style={{fontSize: '24px', fontWeight: 'bold'}}>50+</div>
              </div>
              <div style={{background: 'rgba(255,255,255,0.15)', borderRadius: '8px', padding: '16px'}}>
                <div style={{fontSize: '14px', opacity: 0.9, marginBottom: '4px'}}>Tasa de Éxito</div>
                <div style={{fontSize: '24px', fontWeight: 'bold'}}>98%</div>
              </div>
            </div>
            <div style={{marginTop: '24px', paddingTop: '24px', borderTop: '1px solid rgba(255,255,255,0.3)'}}>
              <h5 style={{fontSize: '18px', fontWeight: 'bold', marginBottom: '12px'}}>Tecnologías Core:</h5>
              <div style={{display: 'flex', flexWrap: 'wrap', gap: '8px'}}>
                {technologies.map((tech, i) => (
                  <span key={i} style={{background: 'rgba(255,255,255,0.2)', padding: '6px 12px', borderRadius: '16px', fontSize: '14px'}}>
                    {tech}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </section>

        <div style={{marginTop: '32px', padding: '24px', background: 'linear-gradient(to right, #334155, #1e293b)', borderRadius: '12px', color: 'white'}}>
          <h3 style={{fontSize: '20px', fontWeight: 'bold', marginBottom: '8px'}}>Conclusión</h3>
          <p style={{fontSize: '14px', opacity: 0.9, lineHeight: '1.6', margin: 0}}>
            Tracker ON representa una oportunidad única de crear un activo tecnológico escalable en un mercado 
            vertical con alta demanda. Desarrollado por Redeprog con tecnología de punta y metodología de desarrollo 
            asistido por IA (40%), la estrategia híbrida permite minimizar riesgos mientras se construye 
            un producto SaaS con potencial de valuación superior a $4M USD en 3 años.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ExecutiveSummary;